<template>
  <router-view/>
</template>

<style lang="scss">
@font-face {
  font-family: "Sansation";
  src: url("./assets/fonts/Sansation-Regular.otf");
  font-weight: 400;
}

@font-face {
  font-family: "Sansation";
  src: url("./assets/fonts/Sansation-Bold.otf");
  font-weight: 700;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: "Sansation", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
